import React, { FC } from "react";

/**
 * Font Awesome's `image-circle-plus`, inlined.
 *
 * The glyph exists only in Font Awesome 7 and this repo is on 6.4.2. Upgrading
 * for one icon is not worth it: v7 renders every icon fixed-width by default,
 * which shifts the alignment of every icon in the React app and in the legacy
 * pages. So the path is copied out of `pro-regular-svg-icons@7.3.1` — the Pro
 * licence this repo already holds — and no dependency moves. Eight sibling
 * icons here are inline SVG for the same kind of reason.
 *
 * `viewBox` is Font Awesome's own 640x512 canvas; `fill="currentColor"` so it
 * takes `color` like every other icon in this directory.
 */
export const ImageCirclePlus: FC<JSX.IntrinsicAttributes> = (props) => (
  <svg viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M128 80l320 0c8.8 0 16 7.2 16 16l0 82.7c10.4-1.7 21.1-2.7 32-2.7 5.4 0 10.7 .2 16 .7L512 96c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96l0 320c0 35.3 28.7 64 64 64l212 0c-10.5-14.6-19-30.7-25.1-48L128 432c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16zM348.7 211.8c-4.3-7.3-12.2-11.8-20.7-11.8s-16.4 4.5-20.7 11.8l-46.5 79-17.2-24.6c-4.5-6.4-11.8-10.2-19.7-10.2s-15.2 3.8-19.7 10.2l-56 80c-5.1 7.3-5.8 16.9-1.6 24.8S159.1 384 168 384l136.7 0c-.4-5.3-.7-10.6-.7-16 0-53.2 21.6-101.3 56.5-136l-11.8-20.1zM192 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
      fill="currentColor"
    />
  </svg>
);
